// Encrypts a secret with RSA-OAEP (SHA-256) using the public key supplied in
// REACT_APP_LOGIN_PUBLIC_KEY (PEM, SPKI format). The backend must hold the
// matching private key and decrypt the base64 ciphertext.

const pemToArrayBuffer = (pem) => {
  const b64 = pem.replace(/-----(BEGIN|END) PUBLIC KEY-----/g, "").replace(/\s+/g, "");
  const bin = atob(b64);
  const buf = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
  return buf.buffer;
};

const toBase64 = (buffer) => {
  let s = "";
  new Uint8Array(buffer).forEach((b) => (s += String.fromCharCode(b)));
  return btoa(s);
};

export const isPasswordEncryptionEnabled = () => !!process.env.REACT_APP_LOGIN_PUBLIC_KEY;

export const encryptPassword = async (plain) => {
  const pem = (process.env.REACT_APP_LOGIN_PUBLIC_KEY || "").replace(/\\n/g, "\n");
  const key = await window.crypto.subtle.importKey(
    "spki",
    pemToArrayBuffer(pem),
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
  const cipher = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    key,
    new TextEncoder().encode(plain)
  );
  return toBase64(cipher);
};
